import * as React from 'react';
export var IconDrag = React.forwardRef(function IconDrag({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M2.75 5a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Zm0 4a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M5.753 9a.75.75 0 1 0 0 1.5H18.25a.75.75 0 0 0 0-1.5H5.753Zm0 4a.75.75 0 0 0 0 1.5H18.25a.75.75 0 0 0 0-1.5H5.753Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M5.753 9a.75.75 0 1 0 0 1.5H18.25a.75.75 0 0 0 0-1.5H5.753Zm0 4a.75.75 0 0 0 0 1.5H18.25a.75.75 0 0 0 0-1.5H5.753Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
